import { tButtonClickHandler } from "../types"

export const clearGridSelection: tButtonClickHandler = (e, { gridApi, context }) => {
    gridApi.deselectAll()
    context.clearFocusedCellState()
}
